import { render } from "./TheText.vue?vue&type=template&id=ef9b2dc0"
import script from "./TheText.vue?vue&type=script&lang=js"
export * from "./TheText.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__